/* eslint-disable react/no-unknown-property */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-lines-per-function */
import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';
import { enviarEmail } from '../../services/contratos/index';
import './styles.css';
import api from '../../services/backAxios';
import { verificarSeExisteDependentePet, verificarSubGrupoJaVendePet } from './helpers/aditivos';
import { planosDiferenciadosCidadesCeara } from '../dependentesv2/regrasPorPlano/selecaoCidadesPorPlano/cidadesCeara';

export default function Pdf(props) {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sucesso, setSucesso] = useState(false);
    const [erro, setErro] = useState(false);
    const [espelhoBase64, setEspelhoBase64] = useState('');
    const mensagem = useRef(null); //

    const mostrarMensagemErro = () => {
        mensagem.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Não gerar PDF do contrato. Tente novamente mais tarde.',
            life: 4000,
            closable: false
        });
    };

    const dependentes =
        props.dependentes.length > 0 ?
            props.dependentes :
            [{
                Seq: 0,
                Nome: 'Sem dependentes',
                valorDependente: '0,00'
            }];

    let SubGrupo = '';

    if (props.Associado.SubGrupo.trim().substr(0, 2) === 'ZS') {
        if (props.Associado.UF === 'TO') {
            SubGrupo = 'ZSTO';
        }

        if (props.Associado.UF === 'CE') {
            SubGrupo = 'ZSCE';
        }
    } else {
        SubGrupo = props.Associado.SubGrupo.substr(0, 5).trim().toUpperCase();
    }

    let valorTotal;
    let valorDependentes;
    let totalDeMensalidades;
    const valorDesconto = 0.9;

    switch (props.Associado.SubGrupo.trim()) {
    case 'ZP4':
        totalDeMensalidades = 48;
        valorTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(
            props.Associado['ProdutosPreco.valorBase'] +
                props.valorDep * totalDeMensalidades * valorDesconto
        );
        valorDependentes = props.valorDep * totalDeMensalidades * valorDesconto;
        break;
    case 'ZPA':
        totalDeMensalidades = 12;
        valorTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(
            props.Associado['ProdutosPreco.valorBase'] +
                props.valorDep * totalDeMensalidades * valorDesconto
        );
        valorDependentes = props.valorDep * totalDeMensalidades * valorDesconto;
        break;
    case 'ZPCA':
        totalDeMensalidades = 11;
        valorTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(
            props.Associado['ProdutosPreco.valorBase'] +
                props.valorDep * totalDeMensalidades
        );
        valorDependentes = props.valorDep * totalDeMensalidades;
        break;
    case 'ZPC4':
        totalDeMensalidades = 47;
        valorTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(
            props.Associado['ProdutosPreco.valorBase'] +
                props.valorDep * totalDeMensalidades
        );
        valorDependentes = props.valorDep * totalDeMensalidades;
        break;
    default:
        valorTotal = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(props.Associado['ProdutosPreco.valorBase'] + props.valorDep);
        valorDependentes = props.valorDep;
        break;
    }

    let valorTotalSplit = valorTotal.split(' ');

    valorTotalSplit = parseFloat(valorTotalSplit[1].replace(',', '.')).toFixed(2);
    valorTotalSplit -= props.Associado.valorComDesconto ?
        props.Associado.valorComDesconto :
        0;

    valorTotalSplit = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(valorTotalSplit);

    const enviarEmailContrato = async () => {
        setLoading(true);

        await enviarEmail(props.inscricao)
            .then(resp => {
                if (resp.status === 200) {
                    setLoading(false);
                    setSucesso(true);
                }
            })
            .catch(_err => {
                setErro(true);
            });
        setTimeout(() => {
            setSucesso(false);
            setErro(false);
        }, 10000);
    };

    const selectContrato = () => {
        const { Associado } = props;
        const { SubGrupo, idCemiterio, TipoVenda, troca, CodigoCidadeIbge } = Associado;
        const subGrupoAjustado = SubGrupo.trim();
        const inicioSubGrupo = subGrupoAjustado.substr(0, 2);

        if (inicioSubGrupo === 'ZS' && subGrupoAjustado.substr(0, 3) !== 'ZSUC' && idCemiterio) {
            if(troca===true)
            {
                if (planosDiferenciadosCidadesCeara.includes(CodigoCidadeIbge)){
                    return obterPDFparaZSCidadesTroca(idCemiterio);
                }

                return obterPDFparaZSTroca(idCemiterio);
            }
            else
            {
                if(TipoVenda.trim()==='REAB')
                {
                    if (planosDiferenciadosCidadesCeara.includes(CodigoCidadeIbge)){
                        return obterPDFparaZSCidadesReabilitacao(idCemiterio);
                    }
    
                    return obterPDFparaZSReabilitacao(idCemiterio);
                }
                else
                {
                    if (planosDiferenciadosCidadesCeara.includes(CodigoCidadeIbge)){
                        return obterPDFparaZSCidades(idCemiterio);
                    }

                    return obterPDFparaZS(idCemiterio);
                }
            }
        }

        if (verificarSeExisteDependentePet(dependentes) !== -1 && !verificarSubGrupoJaVendePet(Associado.SubGrupo.trim())) {
            const link = document.createElement('a');

            link.href = require('../../files/clausulas/aditivoPet.pdf');
            link.download = 'Termo aditivo PET.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        const subGrupo = subGrupoAjustado.substr(0, 5).toUpperCase();

        return require(`../../files/clausulas/${subGrupo}.pdf`);
    };

    const obterPDFparaZS = idCemiterio => {
        const cemiterios = {
            1: 'ZSTO',
            2: 'ZS',
            3: 'ZSCE_MP',
            4: 'ZSCE_MP',
            6: 'ZSTO',
            7: 'ZSCE_TP',
            8: 'ZSCE_TP',
            9: 'ZSCE_MF',
            10: 'ZSCE_MF'
        };

        if (cemiterios[idCemiterio]) {
            return require(`../../files/clausulas/${cemiterios[idCemiterio]}.pdf`);
        }
    };

    const obterPDFparaZSCidades = idCemiterio => {
        const cemiterios = {
            1: 'ZSTO',
            2: 'ZS',
            3: 'ZSCE_MP_CIDADES',
            4: 'ZSCE_MP_CIDADES',
            6: 'ZSTO',
            7: 'ZSCE_TP_CIDADES',
            8: 'ZSCE_TP_CIDADES',
            9: 'ZSCE_MF_CIDADES',
            10: 'ZSCE_MF_CIDADES'
        };

        if (cemiterios[idCemiterio]) {
            return require(`../../files/clausulas/${cemiterios[idCemiterio]}.pdf`);
        }
    };

    const obterPDFparaZSTroca = idCemiterio => {
        const cemiterios = {
            1: 'ZSTO',
            2: 'ZS',
            3: 'ZSCE_MP_TROCA',
            4: 'ZSCE_MP_TROCA',
            6: 'ZSTO',
            7: 'ZSCE_TP_TROCA',
            8: 'ZSCE_TP_TROCA',
            9: 'ZSCE_MF_TROCA',
            10: 'ZSCE_MF_TROCA'
        };

        if (cemiterios[idCemiterio]) {
            return require(`../../files/clausulas/${cemiterios[idCemiterio]}.pdf`);
        }
    };

    const obterPDFparaZSCidadesTroca = idCemiterio => {
        const cemiterios = {
            1: 'ZSTO',
            2: 'ZS',
            3: 'ZSCE_MP_CIDADES_TROCA',
            4: 'ZSCE_MP_CIDADES_TROCA',
            6: 'ZSTO',
            7: 'ZSCE_TP_CIDADES_TROCA',
            8: 'ZSCE_TP_CIDADES_TROCA',
            9: 'ZSCE_MF_CIDADES_TROCA',
            10: 'ZSCE_MF_CIDADES_TROCA'
        };

        if (cemiterios[idCemiterio]) {
            return require(`../../files/clausulas/${cemiterios[idCemiterio]}.pdf`);
        }
    };

    const obterPDFparaZSReabilitacao = idCemiterio => {
        const cemiterios = {
            1: 'ZSTO',
            2: 'ZS',
            3: 'ZSCE_MP_REAB',
            4: 'ZSCE_MP_REAB',
            6: 'ZSTO',
            7: 'ZSCE_TP_REAB',
            8: 'ZSCE_TP_REAB',
            9: 'ZSCE_MF_REAB',
            10: 'ZSCE_MF_REAB'
        };

        if (cemiterios[idCemiterio]) {
            return require(`../../files/clausulas/${cemiterios[idCemiterio]}.pdf`);
        }
    };

    const obterPDFparaZSCidadesReabilitacao = idCemiterio => {
        const cemiterios = {
            1: 'ZSTO',
            2: 'ZS',
            3: 'ZSCE_MP_CIDADES_REAB',
            4: 'ZSCE_MP_CIDADES_REAB',
            6: 'ZSTO',
            7: 'ZSCE_TP_CIDADES_REAB',
            8: 'ZSCE_TP_CIDADES_REAB',
            9: 'ZSCE_MF_CIDADES_REAB',
            10: 'ZSCE_MF_CIDADES_REAB'
        };

        if (cemiterios[idCemiterio]) {
            return require(`../../files/clausulas/${cemiterios[idCemiterio]}.pdf`);
        }
    };

    const gerarPdfContrato = async () => {
        setLoading(true);

        try {
            const { data } = await api.get(
                `/pdf/espelho-contrato/${props.inscricao}`
            );

            setEspelhoBase64(data);
            setShow(true);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            mostrarMensagemErro();
            throw new Error(error);
        }
    };

    return (
        <div style={{ height: '200px' }}>
            <Growl ref={mensagem} />
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                    <button
                        type="submit"
                        icon="pi pi-plus"
                        iconPos="left"
                        className="btn-primary"
                        onClick={enviarEmailContrato}
                    >
                        Enviar contrato por Email
                    </button>
                </div>

                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                    <Button label="Gerar contrato em PDF" onClick={gerarPdfContrato} />
                </div>

                <div className="p-col-12 p-md-3 p-lg-3 p-sm-3">
                    <Button
                        label="Cláusulas contratuais"
                        className="p-button-warning"
                        onClick={() => {
                            window.open(selectContrato());
                        }}
                    />
                </div>
            </div>

            {loading && (
                <div>
                    <ProgressSpinner
                        style={{
                            width: '100px',
                            height: '100px'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration=".5s"
                    />
                </div>
            )}

            {show && (
                <a
                    href={`data:application/pdf;base64,${espelhoBase64}`}
                    download={`Contrato_${props.inscricao}.pdf`}
                >
                    <Button
                        className="p-button-secondary"
                        label={'Documento gerado, clique para baixar'}
                        onClick={() => setShow(false)}
                    />
                </a>
            )}
            <div>
                <br />
                <br />
                <div className="quinhentos p-col-6 p-md-6">
                    {sucesso && <Message severity="success" text="Contrato enviado" />}
                    {erro && (
                        <Message severity="error" text="Ops, não conseguimos salvar" />
                    )}
                </div>
            </div>
        </div>
    );
}
